import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=2ccc639a&scoped=true"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignment.vue?vue&type=style&index=0&id=2ccc639a&prod&scoped=true&lang=css"
import style1 from "./TaskAssignment.vue?vue&type=style&index=1&id=2ccc639a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc639a",
  null
  
)

export default component.exports